import ActionCard from '@/app/components/molecules/ActionCard';
import WeatherCard from '@/app/components/molecules/WeatherCard';
import type { ActionCardData } from '@/app/components/types';

interface ActionGridProps {
  actions: ActionCardData[];
  mapCard: ActionCardData;
}

/**
 * @component ActionGrid
 * @description Two-column grid of action cards, a weather card, and a full-width
 * "Open Interactive Map" card. Rendered as a semantic `<ul>` list.
 * @param actions - Array of action card data objects to display in the grid.
 * @param mapCard - Data for the "Open Interactive Map" card (href + external when available, disabled when not).
 * @returns A `<ul>` grid layout containing action cards and a weather card.
 */
export default function ActionGrid({ actions, mapCard }: ActionGridProps) {
  // 3 action cards (active/expired): Map full-width at bottom, Weather half-width beside last card
  // 2 action cards (non-member): Map first at half-width, then action cards, Weather last
  const isFull = actions.length >= 3;
  return (
    <ul role="list" className="col-span-2 grid grid-cols-2 gap-4">
      {!isFull && (
        <li className="flex">
          <ActionCard {...mapCard} />
        </li>
      )}
      {actions.map((action) => (
        <li key={action.title} className="flex">
          <ActionCard {...action} />
        </li>
      ))}
      <li className="col-span-2 md:col-span-1 flex">
        <WeatherCard />
      </li>
      {isFull && (
        <li className="col-span-2 flex">
          <ActionCard {...mapCard} compact />
        </li>
      )}
    </ul>
  );
}
